import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/ProductReview/ProductReview';

export const ProductReviewsPage = withLegacyProviders(Page);
